import React from "react";
import { ArrowRight } from "lucide-react";
export default function ProductCard({ item }) {
  return (
    <article className="group relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-base to-light hover:shadow-gold transition-shadow duration-500">

      <div className="relative h-56">
        <img src={item.img} alt={item.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold tracking-wide text-center">{item.title}</h3>
        <p className="mt-1 text-sm text-neutral-400 text-center">{item.desc}</p>
        <div className="mt-4 flex items-center justify-center">
          <a href="#contact" className="text-sm text-yellow-200 hover:text-yellow-100 inline-flex items-center gap-1">
            Enquire <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </article>
  );
}
